import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import curriculamService from "./curriculamService";
// import axios from "axios";
import Papa from "papaparse";

export const importCurriculumCSV = createAsyncThunk(
  "curriculam/importCSV",
  async (file) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          resolve(results.data);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
);

export const getCurriculams = createAsyncThunk(
  "curriculam/get-curriculam",
  async (thunkAPI) => {
    try {
      return await curriculamService.getCurriculamAll();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAEnquiry = createAsyncThunk(
  "enquiry/delete-enquiry",
  async (id, thunkAPI) => {
    try {
      return await curriculamService.deleteEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getAEnquiry = createAsyncThunk(
  "enquiry/get-enquiry",
  async (id, thunkAPI) => {
    try {
      return await curriculamService.getEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAEnquiry = createAsyncThunk(
  "enquiry/update-enquiry",
  async (enq, thunkAPI) => {
    try {
      return await curriculamService.udpateEnquiry(enq);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getGraphDataList = createAsyncThunk(
  "graphdata/get-graphdata",
  async (thunkAPI) => {
    try {
      return await curriculamService.getGraphDataList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCurriculamCompletionCount = createAsyncThunk(
  "completionCount/get-completionCount",
  async (id, thunkAPI) => {
    try {
      return await curriculamService.getCurriculamCompletionCount(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

export const resetState = createAction("Reset_all");

const initialState = {
  curriculams: [],
  graphData:[],
  completionCount:[],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const curriculamSlice = createSlice({
  name: "curriculam",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCurriculams.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCurriculams.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.curriculams = action.payload;
        // state.curriculams9th = action.payload.class9;
        // state.curriculams10th = action.payload.class10;
        // state.curriculams11th = action.payload.class11;
        // state.curriculams12th = action.payload.class12;
      })
      .addCase(getCurriculams.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedEnquiry = action.payload;
      })
      .addCase(deleteAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enqName = action.payload.name;
        state.enqMobile = action.payload.mobile;
        state.enqEmail = action.payload.email;
        state.enqComment = action.payload.comment;
        state.enqStatus = action.payload.status;
      })
      .addCase(getAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedEnquiry = action.payload;
      })
      .addCase(updateAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getGraphDataList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGraphDataList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.graphData = action.payload;
      })
      .addCase(getGraphDataList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getCurriculamCompletionCount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCurriculamCompletionCount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.completionCount = action.payload;
      })
      .addCase(getCurriculamCompletionCount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default curriculamSlice.reducer;
